import { Children, useId, useLayoutEffect, useRef, useState } from 'react';
import { useFormReadiness } from '../forms/ValidatedForm';

export default function AdminSections({ label, children }) {
  const sections = Children.toArray(children);
  const [active, setActive] = useState(0);
  const id = useId();
  const root = useRef(null);
  const { issues, showFeedback } = useFormReadiness();
  const visibleIssues = showFeedback ? issues : [];
  useLayoutEffect(() => {
    const node = root.current;
    const reveal = event => {
      const index = sections.findIndex((_, index) => node.querySelector(`[id="${id}-panel-${index}"]`)?.contains(event.target));
      if (index >= 0) setActive(index);
    };
    node.addEventListener('reveal-form-field', reveal);
    return () => node.removeEventListener('reveal-form-field', reveal);
  }, [id, sections]);
  return <div className="admin-sections" ref={root}>
    <label className="admin-section-picker">Edit section
      <select value={active} aria-controls={`${id}-panel-${active}`} onChange={event => setActive(Number(event.target.value))}>
        {sections.map((section, index) => <option key={section.key} value={index}>{section.props['data-section-label']}{visibleIssues.some(({ field }) => field.closest('[data-admin-section]')?.id === `${id}-panel-${index}`) ? ' — needs attention' : ''}</option>)}
      </select>
    </label>
    <div className="admin-section-tabs" role="tablist" aria-label={label} onKeyDown={event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? sections.length - 1 : (active + (event.key === 'ArrowLeft' ? -1 : 1) + sections.length) % sections.length;
      setActive(next);
      document.getElementById(`${id}-tab-${next}`).focus();
    }}>
      {sections.map((section, index) => {
        const incomplete = visibleIssues.some(({ field }) => field.closest('[data-admin-section]')?.id === `${id}-panel-${index}`);
        return <button key={section.key} type="button" role="tab" id={`${id}-tab-${index}`} aria-controls={`${id}-panel-${index}`} aria-selected={active === index} tabIndex={active === index ? 0 : -1} onClick={() => setActive(index)}>
          {section.props['data-section-label']}{incomplete && <span className="admin-section-incomplete" title="Has incomplete or invalid fields" aria-label="Has incomplete or invalid fields">!</span>}
        </button>;
      })}
    </div>
    {sections.map((section, index) => <div key={section.key} role="tabpanel" id={`${id}-panel-${index}`} data-admin-section aria-labelledby={`${id}-tab-${index}`} hidden={active !== index}>{section}</div>)}
  </div>;
}
